<template>
  <div class="loginPage">
    <myHeader :noBottomLine="true" :showHome="false" :showBack="true">
      <div slot="title">{{ hasLoginToken ? '登录' : '登录新企业' }}</div>
      <div slot="right" v-if="hasLoginToken">
        <img src="@img/warn.png" @click="goLoginDesc" class="warnImg" />
      </div>
    </myHeader>
    <div class="forms" style="margin-top: 75px">
      <div class="form-group">
        <input @keydown="cleanErr('errorinvitedCode')" class="input-control" v-model="invitedCode" placeholder="请输入邀请码" />
        <img src="@img/rm.png" class="rmIcon" v-if="invitedCode" @click="removeInviteCode" />
      </div>
      <div v-show="errorinvitedCode" class="errorTip" style="padding: 7px 0 0">{{ errorinvitedCode }}</div>
      <!-- 1、首次登录 -->
      <div class="invite-desc" v-if="hasLoginToken">
        <div>*首次登录，需输入邀请码</div>
        <div>如您不知道邀请码，可咨询公司相关负责人</div>
      </div>
      <!-- 2、登录新企业 -->
      <div class="invite-desc" v-else>*输入新企业的邀请码</div>
      <!-- 图形验证码 -->
      <div class="form-group" v-if="isShowImgCaptcha">
        <input @keydown="cleanErr('errorImgCode')" class="input-control" v-model="imgCode" placeholder="图形验证码" />
        <img :src="imgUrl" alt class="ic-pic" @click="getImgCaptchaCode" />
      </div>
      <div v-show="errorImgCode" class="errorTip">{{ errorImgCode }}</div>
      <div v-show="errorTip" class="errorTip" style="margin: 0 25px">{{ errorTip }}</div>
      <div class="loginBtn" @click="doLogin()" style="margin-top: 50px">
        <span :style="invitedCode ? { color: 'rgba(255, 255, 255, 1)' } : { color: 'rgba(255, 255, 255, 0.3)' }">登 录</span>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox, Toast } from 'mint-ui'
import { isEmpty } from '@yxcx/util'
import account from '@lib/account'
import userService from '@svc/user'
import myHeader from '@comp/header'
import Service from '@svc/login'
import { jump } from '@util/function'
import { app } from '@util/platform'
import { forbidCookie, navigateBackMiniProgram } from './use/useLogin'
import { toLoginDesc, toLogin } from '@util/navigation'
import setDocumentTitle from '@util/document-title'
import './login.less'

const EMPTY_INVITE = '请输入邀请码 ~'
const EMPTY_IMG = '请输入图形验证码 ~'
const WRONG_IMG = '图形验证码错误 ~'

/**
 * 输入邀请码
 * 1、url 存在 loginToken，表示从登录页过来
 * 2、url 不存在 loginToken，登录新企业
 */
export default {
  data() {
    return {
      firstLogin: true,
    }
  },
  components: {
    myHeader,
  },
  data() {
    return {
      isOffline: false,
      errorTip: '',
      loading: false,
      isShowImgCaptcha: false,
      imgUrl: '',
      imgKey: '',
      imgCode: '',
      invitedCode: '',
      errorinvitedCode: '',
      errorImgCode: '',
      firstLogin: false,
    }
  },
  computed: {
    loginToken() {
      return this.$route.query.loginToken
    },
    hasLoginToken() {
      return !isEmpty(this.loginToken)
    },
  },
  mounted() {
    setDocumentTitle(this.hasLoginToken ? '登录' : '登录新企业')
  },
  methods: {
    removeInviteCode() {
      this.invitedCode = ''
      this.errorinvitedCode = ''
      this.errorTip = ''
    },
    async doLogin() {
      if (forbidCookie()) return
      if (this.loading) return
      if (this.checkFields()) return
      this.loading = true
      try {
        const { imgKey, imgCode } = this
        let opts = {
          imgKey,
          imgCode,
        }
        await this.bindMobile(opts)
      } catch (e) {
        console.error(e)
        this.loginError(e)
      } finally {
        this.loading = false
      }
    },
    checkFields() {
      if (!this.invitedCode) {
        return (this.errorinvitedCode = EMPTY_INVITE)
      }
      if (this.isShowImgCaptcha && !this.imgCode) return (this.errorImgCode = EMPTY_IMG)
    },
    bindMobile(opts) {
      return new Promise(async (resolve, reject) => {
        try {
          let res
          let params = {
            ...opts,
            inviteCode: this.invitedCode,
          }

          if (this.hasLoginToken) {
            params.loginToken = this.loginToken
            res = await Service.bindMobile(params)
          } else {
            res = await Service.bindMobileInside(params)
          }

          // 小程序
          if (app.isMiniProgram()) {
            navigateBackMiniProgram(res)
            return reject()
          }

          let redirectUri = this.getRedirectUri(res.mallInfo.mallCode)
          account.setLoginSuccessData(res)
          jump({
            url: redirectUri,
          })
          resolve()
        } catch (e) {
          reject(e)
        }
      })
    },
    cleanErr(type) {
      this[type] = ''
      this.errorTip = ''
    },
    getRedirectUri(code) {
      let redirectUri = this.$route.query.redirectUri
      if (redirectUri) {
        redirectUri = redirectUri.replace(/\/ka\/[0-9a-zA-Z-]{1,}/, '/ka/' + code)
      }
      return redirectUri || process.env.VUE_APP_KAOP_MALL_HOST + '/ka/' + code
    },
    loginError(e) {
      if (!e) return

      // 请输入图形验证码 | 图形验证码错误
      if ([6006, 6007].includes(e.status)) {
        this.isShowImgCaptcha = true
        this.errorTip = ''
        this.errorImgCode = e.status === 6006 ? WRONG_IMG : EMPTY_IMG
        this.getImgCaptchaCode()
        return
      }
      // 前端兑换页已关闭
      if (e.status === 70019) {
        MessageBox.alert(e.msg)
        return
      }
      // 登录超时
      if (e.status === 70005) {
        Toast({
          message: e.msg,
          position: 'bottom',
          duration: 3000,
        })
        return toLogin()
      }
      // 绑定失败
      if (e.status === 70022) {
        this.errorinvitedCode = e.msg
        this.errorTip = ''
        return
      }
      this.errorTip = e.msg || '登录失败'
    },
    // 获取图文验证码
    async getImgCaptchaCode() {
      try {
        this.loading = true
        let res = await userService.getImgCaptcha()
        this.imgUrl = res.imgUrl
        this.imgKey = res.imgKey
      } catch (e) {
        this.errorImgCode = e.msg
      } finally {
        this.loading = false
      }
    },
    goLoginDesc() {
      toLoginDesc({
        router: this.$router,
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import './login.less';
</style>
